/**
 * Parse `system_note` an toàn — có thể là JSON string hoặc object (socket/API).
 * @param {unknown} systemNote
 * @returns {Record<string, unknown>|null}
 */
export function parseChatSystemNote(systemNote) {
  if (systemNote == null || systemNote === '') {
    return null;
  }
  if (typeof systemNote === 'object' && !Array.isArray(systemNote)) {
    return systemNote;
  }
  if (typeof systemNote !== 'string') {
    return null;
  }
  try {
    const parsed = JSON.parse(systemNote);
    return parsed && typeof parsed === 'object' && !Array.isArray(parsed) ? parsed : null;
  } catch (e) {
    void e;
    return null;
  }
}

/**
 * @param {unknown} systemNote
 * @returns {boolean}
 */
export function isChatStickerMessage(systemNote) {
  const note = parseChatSystemNote(systemNote);
  if (!note) {
    return false;
  }
  const sticker = note.sticker;
  return sticker === true || sticker === 1 || sticker === '1' || sticker === 'true';
}

/**
 * Laravel Resource đôi khi bọc thêm `{ data: { ... } }` (API hoặc socket).
 * @param {Record<string, unknown>|null|undefined} payload
 * @returns {Record<string, unknown>|null|undefined}
 */
export function unwrapChatMessagePayload(payload) {
  if (!payload || typeof payload !== 'object') {
    return payload;
  }
  if (payload.group_id != null) {
    return payload;
  }
  const inner = payload.data;
  if (inner && typeof inner === 'object' && inner.group_id != null) {
    return inner;
  }
  return payload;
}

/**
 * Chuẩn hóa 1 tin chat từ API/socket/cache — luôn có `files[]`, `poll[]`.
 * @param {Record<string, unknown>|null|undefined} row
 * @returns {Record<string, unknown>|null|undefined}
 */
export function normalizeChatMessageRow(row) {
  if (!row || typeof row !== 'object') {
    return row;
  }
  const next = { ...row };
  if (!Array.isArray(next.files)) {
    next.files = next.files != null && typeof next.files === 'object' ? [next.files] : [];
  }
  if (next.poll == null) {
    next.poll = [];
  }
  if (next.mentions == null) {
    next.mentions = [];
  }
  return next;
}

/**
 * @param {Array<Record<string, unknown>>|null|undefined} rows
 * @returns {Array<Record<string, unknown>>}
 */
export function normalizeChatMessageRows(rows) {
  if (!Array.isArray(rows)) {
    return [];
  }
  return rows.map((row) => normalizeChatMessageRow(row));
}
